import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { DrawdownInstructionClient } from "../../../../../../../../Wrap/Api/Drawdown/DrawdownInstruction";
import { DrawdownRequestClient } from "../../../../../../../../Wrap/Api/Drawdown/DrawdownRequest";
import { ImmediateTaxFreeCashIncomeRequestClient } from "../../../../../../../../Wrap/Api/Drawdown/ImmediateTaxFreeCashIncomeRequest";
import { DrawdownModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { DrawdownCalculationStoreDispatcher } from "../Store/Variable";

export class DrawdownCalculationAction {
    public static doCalculate(callback?) {
        if (callback) {callback();}
    }

    public static postDrawdown(hiercharyId, model, callback, isTakePensionBenefitsWizard = false) {
        const client = new DrawdownInstructionClient();
        DrawdownCalculationStoreDispatcher.dispatch({ actionType: ActionType.Loading, payload: true });
        const promise = client.post(hiercharyId, model, isTakePensionBenefitsWizard);
        promise.onSuccess((result) => {
            DrawdownCalculationStoreDispatcher.dispatch({ actionType: ActionType.Loading, payload: false });
            callback(result.Result);
        });
        promise.onError((error) => {});
    }

    public static validateRequestId(requestId: number, drawdownModel: DrawdownModel, isITFC: boolean, callback) {
        const client = new DrawdownRequestClient();
        const promise = client.post(requestId, drawdownModel, isITFC);
        promise.onSuccess((result) => {
            callback(result);
        });
        promise.onError((error) => {
            callback(error);
        });
    }

    public static validateITFCIncomeId(requestId: number, callback){
        const client = new ImmediateTaxFreeCashIncomeRequestClient();
        const promise = client.post(requestId);
        promise.onSuccess((result) => {
            callback(result);
        });
        // TODO backend needs to finish handle error
        promise.onError((error) => {
            callback(error);
        })
    }
}
